import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';

import TransactionListHeader from '../../components/transactions/TransactionListHeader';


const TransactionHeader = ({ orgId, organizations, onSearch, onExport, title, filter }) => {
  const org = organizations.entities[orgId];

  let displayTitle = title;
  if (org) {
    displayTitle = `${org.name} - ${title}`;
  }

  return (
    <TransactionListHeader
      title={displayTitle}
      onFilter={onSearch}
      onExport={onExport}
      filter={filter}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    organizations: state.shared.organizations,
    transactions: state.shared.transactions,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionHeader);
